export default {
	sidebar: {
		admin_header: 'Administration',
		hr_header: 'Human Resources',
		staff_header: 'Crew Management',
		//
		user_dashboard: 'Dashboard',
		user_events: 'Events',
		user_calendar: 'Calendar',
		user_profile: 'Profile',
		user_documents: 'Documents',
		user_timetracking: 'Time Tracking',
		user_mails: 'Messages',
		//
		staff_crews: 'Crews',
		staff_timetracking: 'Time Tracking',
		staff_staffing_requests: 'Staffing requests',
		//
		hr_users: 'People',
		hr_applications: 'Applications',
		hr_staffing_requests: 'Staffing requests',
		hr_subscriptions: 'Subscriptions',
		hr_events: 'Events',
		hr_crews: 'Crews',
		hr_staff_crews: 'Crews',
		hr_schedule_employees: 'Staff Planning',
		hr_contracts: 'Contracts',
		hr_payroll: 'Payroll',
		hr_mails: 'Messages',
		//
		admin_users: 'People',
		admin_settings: 'Settings',
	},
	// Short titles (tooltips) for buttons without a visible label. Keep them to a few words, they
	// only have to tell the user what the button does. Everything generic already lives in the lib,
	// only what this app adds on top belongs here.
	buttons: {
		driving_license: {
			check: 'Mark as seen',
			uncheck: 'Take back',
		},
		quick_registration: {
			copy: 'Copy link',
			open: 'Open page',
			renew: 'Create a new link',
			download_qr: 'Download QR code',
		},
		application: {
			accept: 'Accept application',
			decline: 'Reject application',
			waiting: 'Put on the waiting list',
			publish: 'Send acceptance or rejection',
			publish_all: 'Send all acceptances and rejections',
			info: 'Show application',
			revoke: 'Withdraw application',
		},
		calendar: {
			date_create: 'Create appointment',
			date_delete: 'Delete appointment',
		},
		contract: {
			apply_start: 'Apply start date to the selection',
			apply_end: 'Apply end date to the selection',
			apply_wage: 'Apply hourly wage to the selection',
			generate_all: 'Generate contracts of the selection',
			send_all: 'Send contracts of the selection',
			generate: 'Generate contract',
			preview: 'Show contract',
			send: 'Send contract',
			sign: 'Mark as signed',
			delete: 'Delete draft',
			template_select: 'Select template',
			template_upload: 'Upload template',
		},
		crew: {
			create: 'Create crew',
			edit: 'Edit crew',
			delete: 'Delete crew',
			open: 'Open the crew',
			publish: 'Publish crew',
			unpublish: 'Hide crew',
			rate: 'Enter the experience of the crew',
		},
		event: {
			mail: 'Write to the event',
			publish: 'Publish event',
			unpublish: 'Hide event',
			applications_enable: 'Open applications',
			applications_disable: 'Close applications',
			unlock: 'Unlock event',
			sort: 'Sort events',
			route: 'Plan a route',
			lock: 'Lock event',
		},
		file: {
			open: 'Open file',
			download: 'Download file',
			edit: 'Edit file type',
			delete: 'Delete file',
		},
		mail: {
			compose: 'Write message',
			reply: 'Reply',
			load_more: 'Load older',
		},
		occupation: {
			create: 'Add employment',
			edit: 'Edit employment',
			delete: 'Delete employment',
		},
		payroll: {
			export: 'Download LODAS file',
			take_hours: 'Apply recorded hours',
			save: 'Save payslip',
			check: 'Stamp as checked',
		},
		planning: {
			add_employee: 'Add staff member',
			sort_by_date: 'Sort by application date',
			sort_by_name: 'Sort by first name',
		},
		experience: {
			create: 'Add an experience',
			edit: 'Edit the experience',
			delete: 'Delete the experience',
			delete_rating: 'Remove the experience entry',
		},
		skill: {
			create: 'Create skill',
			edit: 'Edit skill',
			delete: 'Delete skill',
		},
		staffing_request: {
			create: 'Create a staffing request',
			edit: 'Edit the staffing request',
			show: 'Show the staffing request',
			delete: 'Delete the staffing request',
			position_add: 'Add a line of demand',
			position_delete: 'Remove the line of demand',
			requirement_add: 'of them at least …',
			requirement_delete: 'Remove the requirement',
			fill_days: 'Apply the number to every day',
		},
		subscription: {
			mail_all: 'Write to all subscribers',
			mail_event: 'Write to all subscribers of {event}',
			delete: 'Delete subscription',
		},
		timetracking: {
			now: 'Use the current time',
			apply: 'Apply to the selection',
			confirm: 'Confirm',
			dispute: 'Does not fit',
			edit: 'Change times',
			disputed: '1 time does not fit | {count} times do not fit',
			open: '1 time open | {count} times open',
			delete: 'Delete times',
			clock_in: 'Clock in',
			clock_out: 'Clock out',
		},
		user: {
			profile: 'Show person',
			mail: 'Write to the person',
			delete_core_data: 'Delete tax and wage data',
			assign_to_event: 'Add to an event',
		},
	},
	// Short names of the status icons a table uses, spelled out below it by efTableLegend. The
	// longer explanation stays in `popovers`, the legend hands out the very same one on hover.
	legends: {
		calendar: {
			planning: 'Assignment',
			not_available: 'Not available',
			date: 'Appointment',
		},
		application: {
			min_age: 'Under 18',
			minor: 'Under 18 at the event',
			age_unknown: 'Age not known yet',
			unemployed: 'Unemployed, draws Bürgergeld/ALG 1',
			quick_registration: 'Through the quick registration',
			locked: 'Account locked',
		},
		file: {
			uploaded: 'Uploaded by me',
			unread: 'Not read yet',
			read: 'Read',
		},
		timetracking: {
			qr: 'QR code available',
			confirmed: 'Confirmed',
			open: 'Open',
			disputed: 'Does not fit',
		},
		user: {
			address_data_completed: {
				true: 'Address data',
				false: 'Address data missing',
			},
			core_data_completed: {
				true: 'Core data',
				false: 'Core data missing',
			},
			timetracking_counts: {
				none: 'No times',
				missing_lead: 'Crew lead missing',
				missing_member: 'Person missing',
				completed: 'Times confirmed',
			},
		},
		planning: {
			preferred_crew: 'In a preferred crew',
			other_crew: 'In another crew',
			other_event: 'At another event',
			not_available: 'Not available',
			crew_closed: 'The crew does not work that day',
			off_day: 'No day of the crew or the application',
			minor: 'Under 18',
			need_met: 'Need met',
			need_over: 'More than needed',
		},
	},
	pages: {
		intern_info: {
			hint_event: 'Shown on the intern page to everyone taking part in the event.',
			hint_crew: 'Shown on the intern page to everyone planned in the crew.',
			insert_example: 'Insert example text',
			replace_title: 'Insert example text',
			replace_text: 'The example text replaces the text in the editor. Nothing is stored until you save. Continue?',
			// Markdown, the leads adjust the example values
			example_crew: '## Welcome to the {crew} crew\n\nGreat to have you with us! Here is everything you need to know for your shifts.\n\n### Meeting point and start of work\n\n- **Meeting point:** crew container at the north entrance\n- **Start of work:** please arrive 15 minutes before your shift starts\n- You find your shifts above under **Your shifts** and in the calendar.\n\n### What to bring\n\n- ID card\n- Sturdy, closed shoes\n- Weatherproof clothing\n- Your own water bottle\n\n### Time tracking\n\nCheck in with your crew lead at the start and end of your shift; they record your times on site with your QR code. You then find them here in the app under **Time Tracking**. Please check and confirm them there.\n\n### Food\n\nDuring your shift you get food and drinks at the crew catering.\n\n### Questions?\n\nAsk your crew lead. You find the contacts above under **Your contacts**.',
		},
		event_settings: {
			general: {
				title: 'General',
				image: 'Preview image',
				save_first: 'Save first, then upload an image',
				address_data: 'Address',
				display: 'Display',
			},
			crews: {
				title: 'Crews',
			},
			applications: 'Applications',
			quick_registration: {
				status: 'Status & link',
				enabled: 'Quick registration switched on',
				enabled_hint:
					'People without an account sign up for this event through the link. Their account and application are created on the way.',
				closed: {
					deadline: 'The page takes no more sign-ups: the deadline on {date} has passed.',
					applications: 'The page takes no sign-ups because applications are not enabled for the event.',
					applications_link: 'To the events',
					locked: 'The page takes no sign-ups because the event is locked.',
					closed: 'The page takes no registrations right now: the deadline has passed, the event takes no applications or it is locked.',
					ended: 'The event is over, the page takes no more registrations.',
				},
				not_published:
					'The event is not published. People who sign up only see it in their account once it is published.',
				link: 'Link to the registration page',
				link_inactive: 'The link works once the quick registration is switched on and saved.',
				no_link: 'The link is created when the quick registration is switched on and saved for the first time.',
				copied: 'Link copied',
				closes_at: 'Registration deadline',
				closes_at_hint: 'Optional. After it the page says the registration is closed.',
				design: 'Design',
				primary_color: 'Primary colour',
				theme: 'Appearance',
				themes: {
					auto: 'As set on the device',
					light: 'Light',
					dark: 'Dark',
				},
				background: 'Background image',
				background_hint:
					'A large picture at the top of the page, best in landscape and at least 1600 px wide. The logo is the event logo.',
				texts: 'Texts',
				texts_hint:
					"Empty fields show the grey default. {'{'}event{'}'} is replaced by the name of the event, line breaks are kept.",
				text: {
					title: 'Headline',
					subtitle: 'Subline',
					intro: 'Introduction',
					consent: 'Consent',
					success: 'Text after sending',
					mail_subject: 'Subject',
					mail_body: 'Mail text',
				},
				sections: 'Sections',
				closing_texts: 'Closing',
				section_title: 'Headline',
				section_text: 'Text',
				section_fields: 'Also ask',
				field: {
					crews: 'Preferred crews',
					skills: 'Skills',
					shoe_size: 'Shoe size',
					motivation: 'Show this section',
				},
				mail: 'Confirmation mail',
				mail_hint:
					"Separate paragraphs with a blank line. {'{'}firstname{'}'} and {'{'}event{'}'} are replaced. The link to set the password and the list of missing documents always follow.",
			},
			users: {
				title: 'People',
			},
		},
		crew_settings: {
			ratings: {
				hint: 'Only HR sees the experience you enter, the person does not. Every star is saved at once, clicking the same star again takes it back.',
				not_yet: 'Entering experience opens on {date}, when the event begins.',
				search: 'Search a name',
				progress: '{rated} of {total} entered',
				no_experiences: 'No experiences have been set up yet to enter.',
				no_members: 'Nobody is planned in this crew yet.',
				no_match: 'Nobody matches the search.',
				person: 'Person',
				days: 'no day | 1 day | {count} days',
				rated_by: 'Entered by {name}',
			},
			applications: 'Applications',
			users: {
				title: 'People',
			},
			planning: {
				title: 'Staff planning',
				no_days: 'The crew has no days to plan.',
				search: 'Name or FetSy code',
			},
		},
		admin_settings: {
			datev: {
				accountant_id: 'Consultant number',
				client_id: 'Client number',
				occupation_id: 'Occupation key for helpers',
				health_insurance_id: 'Health insurance number',
				wage_type_normal: 'Wage type for worked hours',
				wage_type_tip: 'Wage type for tips',
				wage_type_travel: 'Wage type for travel expenses',
			},
			experiences: {
				title: 'Experiences',
				hint: 'Crew leads enter with 1 to 5 stars how much experience their people have in these, during or after an assignment. Unlike skills, people do not state them and never see them.',
				in_use: 'Used by experience entries or staffing requests, it cannot be deleted',
			},
			user_dashboard: 'Home page',
			user_skills: 'Skills',
			contracts: {
				title: 'Contracts',
				cc_mail: 'E-mail address for copies',
				template: 'Contract template upload',
			},
		},
		user_settings: {
			anonymized: 'This person is anonymized. Their data can no longer be changed.',
			experiences: {
				private_hint: 'Visible to HR only. The person sees neither their levels nor the entries.',
				levels: 'Levels',
				level: 'Level',
				basis: 'Based on',
				override: 'HR value',
				override_hint:
					'An HR value replaces the average of the entries. Clicking the same star again takes it back.',
				override_for: 'HR value for {name}',
				no_experiences: 'No experiences have been set up yet. That happens in the settings.',
				not_rated: 'No experience entered yet',
				average: 'no entry | avg. {average} from 1 entry | avg. {average} from {count} entries',
				overridden: 'set by HR',
				ratings: 'Experience entries',
				no_ratings:
					'No entries yet. Crew leads enter the experience of their people during or after an assignment.',
				when: 'Period',
				event: 'Event',
				crew: 'Crew',
				stars: 'Stars',
				rated_by: 'Entered by',
			},
			//contracts: 'Contracts',
			applications: 'Applications',
			subscriptions: 'Subscriptions',
			events: 'Events',
			contracts: {
				title: 'Contracts',
				general: 'General',
				active_contract: 'Active contract',
			},
		},
		user: {
			event_intern: {
				welcome: 'We look forward to your support. You will hear more from us soon.',
				days: 'Your shifts',
				to_calendar: 'View in calendar',
				today: 'Today',
				contacts: 'Your contacts',
				crew: 'Crew {name}',
				manager: 'Crew lead',
				no_managers: 'No lead has been entered for this crew yet.',
				call: 'Call',
				mail: 'Write an email',
				save_contact: 'Save contact',
				info: 'Information',
				crew_info: 'Information for crew {name}',
				edit_info: 'Edit information',
				documents: 'Documents',
				documents_hint:
					'Shown on the intern page below the text of this information. PDF, images, office files and text up to 20 MB.',
				delete_document: 'Delete document',
				delete_document_text: 'Do you really want to delete the document "{name}"?',
				no_crew_info:
					'No information for your crew yet. What you write here is shown to everyone planned in the crew.',
			},
			events: {
				title: 'Events',
				sort_by: 'Sort by',
				sort_by_date: 'By date',
				sort_by_name: 'By name',
				show_past_events: 'Show past events',
				apply_now: 'Apply now',
				already_applied: 'You have applied.',
				not_accepted: 'Application not selected',
				complete_now: 'Complete your application now',
				completed: 'Application completed successfully',
				revoked: 'You have withdrawn your application',
				added: 'You have been added',
				crew_lead: 'You lead a crew',
				application_not_enabled: 'Applications will open soon',
				locked: 'Applications are closed',
			},
			apply: {
				production: 'Possible work period',
				show: 'Event',
				availability: 'Availability',
				available_all_the_time: 'I am available for the entire work period',
				favorit_crews: 'Select the crews you are most interested in',
				is_favorit_crew: 'I am interested in this crew.',
				//
				back: 'Back',
				next: 'Next',
				//
				step: 'Step',
				//
				crew: 'Choose a crew',
				motivation: 'Motivation',
				contact: 'Contact details',
				qualification: 'Qualification',
				send: 'Submit application',
				accept: 'Accept job',
				core_data: 'Tax and wage data',
				core_data_why:
					'We need these for your contract and your payroll once you are part of the team. You find them in the letter with your tax id and on your social security card.',
				edit: 'Update application',
				revoke: 'Withdraw application',
				student_documents: 'Documents',
				student_documents_info: 'Since you are a student, we need the following documents from you.',
				student_documents_skip: 'I will hand in the documents later.',
				versicherungsbestaetigung: 'Insurance confirmation',
				immatrikulationsbescheinigung: 'Certificate of enrollment',
				parental_consent: 'Consent',
				parental_consent_info:
					'You are not 18 yet at the event. Your contract needs the consent of your parents or guardians.',
				parental_consent_document: 'Consent of the parents or guardians',
				parental_consent_contents:
					'The consent carries the signature of your parents or guardians, your name and the event. A photo or scan is enough.',
				parental_consent_later: 'I will hand in the consent later.',
				parental_consent_needed: 'Upload the consent or tick that you hand it in later.',
				//
				motivation_text: 'What is your motivation to work at this event?',
				experience_text:
					'Have you worked for us before, at this event or at another one? If so, which event was it and what did you do?',
				confirmation:
					'I hereby confirm that the data entered is correct and apply for this event. The exact work period will be determined in a later step.',
			},
			documents: {
				title: 'Documents',
			},
			mails: {
				title: 'Messages',
				empty: 'No messages',
			},
			timetracking: {
				title: 'Time Tracking',
			},
		},
		hr: {
			applications: {
				title: 'Applications',
				publish: 'Send acceptances and rejections',
			},
			events: {
				title: 'Events',
			},
			subscriptions: {
				title: 'Subscriptions',
			},
			persons: {
				title: 'People',
			},
			contracts: {
				title: 'Contracts',
				start_at: 'Start date',
				end_at: 'End date',
				wage: 'Hourly wage',
				no_template: 'No contract template has been uploaded yet.',
				no_template_hint: 'Contracts cannot be generated until a template is available.',
				no_template_action: 'Upload template',
			},
			payroll: {
				title: 'Payroll',
				checked: 'Checked',
				checked_at: 'Checked on {date}. A click takes the check back.',
				exported: 'Exported',
				exported_at: 'Exported on {date}',
				exported_toast: 'LODAS file exported',
				nothing_to_export: {
					title: 'Nothing to export',
					text: '{month} has no checked payslip that has not been exported yet. Tick the finished rows as checked first.',
				},
				not_ready: {
					no_hours: 'No hours yet: a row without hours cannot be checked.',
					data_incomplete:
						'Contact or core data are still missing, the row can be checked once they are complete.',
					times_open: 'Not every time of the month is confirmed by both sides yet.',
				},
				errors: {
					title: 'Payslip not changed',
					payslip_locked: 'The payslip is checked or exported and can no longer be changed.',
					payslip_exported: 'The payslip is already exported, the check stays.',
					payslip_not_ready: 'The payslip no longer belongs to anyone.',
					payslip_no_hours: 'A payslip without hours cannot be checked.',
					payslip_data_incomplete: "The person's contact or core data are still missing.",
					payslip_times_open: 'Not every time of the month is confirmed by both sides yet.',
				},
				check: 'Check',
				filter: {
					all_events: 'All events',
					states: {
						all: 'All payslips',
						open: 'Open',
						checked: 'Checked',
						not_exported: 'Not exported',
					},
				},
			},
			planning: {
				may_drive: 'May drive {class}',
				not_planned: 'Not booked',
				title: 'Staff Planning',
			},
			staffing_requests: {
				title: 'Staffing requests',
			},
			mail: {
				title: 'Messages',
				search: 'Search person or subject',
				read: 'Read',
				read_at: 'Read {date}',
				unread: 'Unread',
			},
		},
		staff: {
			crews: {
				title: 'Crew Management',
			},
			staffing_requests: {
				title: 'Staffing requests',
				empty: 'You have not asked for personnel yet.',
			},
			timetracking: {
				title: 'Time Tracking',
			},
		},
		profile: {
			contact_data: 'Contact details',
			address_data: 'Address',
			additional_information: 'Additional information',
			additional_personal_data: 'Additional personal data',
			declarations_for_taxes: 'Tax classification details',
			bank_details: 'Bank details',
			check_fields: 'Not saved - please check the marked fields',
			apprenticeship: 'Education',
			skills: 'Skills',
			additional_occupation: 'Other employments',
			driving_license: 'Driving licence',
			driving_license_checked: 'Licence seen',
			driving_license_unchecked: 'Licence not seen yet',
			driving_license_save_first: 'Save the changed classes first',
		},
		quick_registration: {
			defaults: {
				title: 'Sign up for {event}',
				subtitle: 'Become part of our team',
				intro: 'Sign up for {event} here. We ask everything we need for your contract and payroll. Afterwards you have an account of your own where you see how your application goes on.',
				consent:
					'I agree that my data is processed for my application and my employment at {event}. I can withdraw this consent at any time.',
				success:
					'Thank you! We received your registration and sent you an e-mail with the link to set the password of your account.',
				mail_subject: 'Your registration for {event}',
				mail_body:
					'thank you for signing up for {event}! We received your data and will get back to you once we have been through the applications.',
			},
			sections: {
				personal: { label: 'Section "About you"', title: 'About you' },
				address: { label: 'Section "Address"', title: 'Address' },
				tax: {
					label: 'Section "Tax & social security"',
					title: 'Tax & social security',
					text: 'We need this for your payroll. You find it in the letter with your tax ID and on your social security card.',
				},
				bank: {
					label: 'Section "Bank account"',
					title: 'Bank account',
					text: 'We pay your wage into this account.',
				},
				work: {
					label: 'Section "Your work"',
					title: 'Your work',
					text: 'Pick every day you can work. We plan the details with you later.',
				},
				motivation: { label: 'Section "Experience & motivation"', title: 'Experience & motivation' },
				consents: { label: 'Section "Finish"', title: 'Finish' },
			},
			progress: '{done} of {total} sections complete',
			intro: {
				duration: 'Takes about 10 minutes',
				secure: 'Sent encrypted',
				has_account: 'Already have an account?',
				login: 'Sign in and apply there',
			},
			days: {
				label: 'Possible working days',
				all: 'All',
				none: 'None',
				required: 'Pick at least one day.',
				phase: {
					assembling: 'Set-up',
					event: 'Event',
					dismantling: 'Dismantling',
				},
			},
			crews: 'Where would you like to work most?',
			skills: 'What do you bring along?',
			minor_hint:
				'You are not 18 yet at the event. That is fine - we only need the consent of your parents or guardians later.',
			privacy_before: 'I have read the',
			privacy_link: 'privacy policy',
			privacy_after: '.',
			correct: 'All data is correct and complete. If anything changes, I let you know right away.',
			incomplete: 'Not complete yet: {sections}',
			submit: 'Send registration',
			required_hint: 'Fields marked with * are required.',
			done: {
				title: 'Registration sent',
				spam_hint: 'No e-mail? Please check your spam folder too.',
				sent_to: 'It went to',
				wrong_address: 'Wrong address? Back to the form to send it again',
			},
			unavailable: {
				invalid: {
					title: 'This link is not valid',
					text: 'It may have been replaced by a new one, or the registration was switched off.',
				},
				closed: {
					title: 'Registration is closed',
					text: 'We are not taking registrations for this event right now.',
				},
			},
			errors: {
				network: 'The registration could not be sent. Check your connection and try again.',
				throttled: 'Too many attempts in a short time. Please wait a minute and try again.',
				unknown: 'Something went wrong. Please try again later.',
				reload: 'Please reload the page and send the registration again.',
				invalid: 'Please check your data in: {sections}',
			},
		},
	},
	data: {
		user: {
			// Contact data
			middelname: 'Middle name',
			sex: 'Gender',
			mobile: 'Phone number',
			address: 'Address',
			street: 'Street',
			street_number: 'House number',
			postcode: 'Postal code',
			city: 'City',
			diet: 'Dietary preference',
			allergies: 'Allergies',
			shirt_size: 'T-shirt size',
			shoe_size: 'Shoe size',
			own_shoes: 'I have my own safety shoes',
			fetsy_code: 'FetSy-Hammertag code',
			// Core data
			birthday: 'Date of birth',
			birth_name: 'Birth name',
			birth_place: 'Place of birth',
			citizenship: 'Citizenship',
			employment_status: 'Employment status',
			employment_status_note: 'Details on other employment',
			civil_status: 'Marital status',
			number_of_children: 'Number of children',
			confession: 'Religious denomination',
			confession_info: 'Relevant for possible church tax deduction',
			social_security_number: 'Social security number',
			skip_social_security_number: 'No social security number available',
			tax_category: 'Tax class',
			tax_ident_number: 'Tax identification number / TIN',
			health_insurance_name: 'Health insurance',
			health_insurance_type: 'Statutory/Private',
			bank_name: 'Bank name',
			iban: 'IBAN',
			bic: 'BIC',
			// Qualifications
			graduation_type: 'School-leaving qualification',
			graduation_name: 'Degree / apprenticeship',
			additional_qualifications: 'Additional qualifications',
			// Driving licence and work permit
			driving_license_classes: 'Driving licence',
			driving_license_checked_at: 'Licence seen',
			work_permit: 'I hold a work permit for Germany',
			work_permit_hint: 'Without an EU, EEA or Swiss citizenship we need a copy of your residence permit later.',
			// Computed values
			// Under 18 on a day of the event
			minor: 'U18',
			address_data_completed: 'Contact data',
			core_data_completed: 'Wage data',
			data_completed: 'Checks',
			// Realtions
			skills: 'Skills',
			experiences: 'Experiences',
			applications: 'Applications',
			// Counts
			applications_count: '# Applications',
			events_count: '# Events',
			assignments: 'Assignments',
			planned_hours: 'Planned hours',
			//
			contract_type: 'Contract type',
			personnel_type: 'Kind of personnel',
			entry_date: 'First entry date',
			active_contract: {
				start_at: 'Start date',
				end_at: 'End date',
				wage: 'Hourly wage',
				state: 'Status',
				available_days: 'Available working days',
				worked_days: 'Days worked',
			},
			contracts: 'Contracts',
			plannings_count: 'Planned working days',
			upcoming_events: 'Booked on',
		},
		experience: {
			id: 'Id',
			preview: 'Preview',
			name: 'Experience',
			color: 'Color',
			description: 'Description',
			ratings_count: '# Experience entries',
			requirements_count: '# Staffing requests',
		},
		staffing_request_requirement: {
			of_them: 'of them at least',
			type: 'Kind of requirement',
			min_level: 'from',
			min_level_hint: 'At least this many stars. Without stars, having the experience at all is enough.',
		},
		user_skill: {
			id: 'Id',
			preview: 'Preview',
			users_count: '# People',
			description: 'Description',
			color: 'Color',
			name: 'Name',
		},
		staffing_request: {
			id: 'Id',
			name: 'Event',
			start_at: 'Start',
			end_at: 'End',
			period: 'Period',
			note: 'Note',
			status: 'Status',
			persons_total: 'Person-days',
			positions: 'Demand',
			created_at: 'Created at',
			user: {
				firstname: 'First name',
				lastname: 'Last name',
			},
		},
		staffing_request_position: {
			persons: 'People',
			qualification: 'Qualification',
			personnel_type: 'Kind of personnel',
			note: 'Note',
			sum: 'Total',
			any: 'No preference',
		},
		application: {
			id: 'Id',
			warning: '',
			user: {
				avatar: '',
				firstname: 'First name',
				lastname: 'Last name',
				email: 'E-mail address',
				mobile: 'Phone number',
				address: 'Address',
				personnel_type: 'Kind of personnel',
				sex: 'Gender',
				postcode: 'Postal code',
				city: 'City',
				skills: 'Skills',
				diet: 'Dietary preference',
				allergies: 'Allergies',
				shirt_size: 'T-shirt size',
				shoe_size: 'Shoe size',
				//
				birthday: 'Date of birth',
				birth_name: 'Birth name',
				birth_place: 'Place of birth',
				citizenship: 'Citizenship',
				driving_license_classes: 'Driving licence',
			},
			event: {
				name: 'Event',
				assembling_start_at: 'Assembly from',
				dismantling_end_at: 'Dismantling until',
			},
			distance: 'Distance',
			available_from: 'Available from',
			available_until: 'Available until',
			planned_days: 'Planned working days',
			crews: 'Crews',
			state: 'Status',
			motivation: 'Motivation',
			experience: 'Experience',
			user_plannings_count: 'Planned working days',
			minor: 'U18',
			source: 'Source',
			days: 'Possible working days',
			arrival_type: 'Arrival',
			employment_preference: 'Preferred kind of employment',
		},
		event: {
			//
			description: 'Description',
			company_name: 'Company name, c/o address',
			legalname: 'Company name',
			street: 'Street',
			street_number: 'House number',
			postalcode: 'Postal code',
			city: 'City',
			status: 'Status',
			//
			applications_count: '# Applications',
			crews_count: '# Crews',
			employees: 'People',
			planned_hours: 'Planned hours',
			plannings_count: 'Planned working days',
			user_plannings_count: 'Planned working days',
		},
		crew: {
			id: 'Id',
			name: 'Name',
			start_at: 'Start',
			end_at: 'End',
			projectnumber: 'Project number',
			image: 'Image',
			description: 'Description',
			event: {
				name: 'Event',
			},
			managers: 'Crew management',
			minimal_employee_counts_sum_count: 'Required person-days',
			plannings_count: 'Planned person-days',
			project_number: 'Project number',
			timetracking: 'Time tracking',
		},
		subscription: {
			user: {
				firstname: 'First name',
				lastname: 'Last name',
				status: 'Status',
				postcode: 'Postal code',
				city: 'City',
				skills: 'Skills',
				experiences: 'Experiences',
			},
			event: {
				name: 'Event',
				assembling_start_at: 'Assembly from',
				dismantling_end_at: 'Dismantling until',
			},
			application: {
				status: 'Application status',
			},
			distance: 'Distance',
		},
		additional_occupation: {
			employer: 'Employer',
			weekly_hours: 'Hours/week',
			work_start_at: 'Start',
			work_end_at: 'End',
			type_of_work: 'Type of employment',
		},
		contract: {
			start_at: 'Start date',
			end_at: 'End date',
			wage: 'Hourly wage',
			state: 'Status',
			data_completed: 'Checks',
			available_days: 'Available working days',
			worked_days: 'Days worked',
		},
		timetracking: {
			id: 'Id',
			date: 'Date',
			start_at: 'Work start',
			end_at: 'Work end',
			worked: 'Working time',
			pause: 'Break time',
			event: {
				name: 'Event',
			},
			crew: {
				name: 'Crew',
			},
			firstname: 'First name',
			lastname: 'Last name',
			is_planned: 'Working day',
			note: 'Note',
			user: {
				lastname: 'Last name',
				firstname: 'First name',
			},
			lead_review: 'Crew lead',
			member_review: 'Crew member',
			own_record: 'Recorded by the person',
		},
		payroll: {
			id: 'Id',
			firstname: 'First name',
			lastname: 'Last name',
			active_contract: {
				state: 'Contract status',
				start_at: 'Start date',
				end_at: 'End date',
			},
			data_completed: 'Checks',
			hours_confirmed: 'Confirmed hours',
			hours_total: 'Total hours',
			work_hours: 'Set hours',
			travel_expenses: 'Travel expenses',
			external_expenses: 'Expenses',
			tip: 'Tips',
			state: 'Status',
			timetracking: 'Time tracking',
			checked: 'Checked',
		},
		file: {
			id: 'Id',
			name: 'Name',
			type: 'Category',
			edit_type: 'Edit category',
			created_at: 'Uploaded at',
			read_at: 'Seen at',
			mimetype: 'File type',
			uploaded_by: 'Uploaded by',
		},
		user_date: {
			name: 'Name',
			date: 'Date',
			color: 'Color',
			note: 'Note',
		},
	},
	enums: {
		user: {
			sex: {
				null: '',
				male: 'male',
				female: 'female',
				diverse: 'diverse',
			},
			diet: {
				no_preference: 'No preferences',
				vegetarian: 'Vegetarian',
				vegan: 'Vegan',
				kosher: 'Kosher',
			},
			tax_category: {
				1: '1 / I',
				2: '2 / II',
				3: '3 / III',
				4: '4 / IV',
				5: '5 / V',
				6: '6 / VI',
			},
			employment_status: {
				pupil: 'Pupil',
				unemployed: 'Unemployed, receiving citizen benefit/ALG1',
				self_employed: 'Self-employed (full-time)',
				employee: 'Full-/part-time employee',
				student: 'I am a full-time student',
				waiting_after_school:
					'I graduated from school this year and am waiting for my apprenticeship/studies to begin.',
				waiting_after_voluntary_service:
					'I finished my voluntary service this year and am waiting for my apprenticeship/studies to begin.',
				other: 'Other',
				apprentice: 'Apprentice',
				dual_student: 'Dual study program',
			},
			type_of_work: {
				marginal: 'Marginal employment',
				non_marginal: 'Non-marginal employment',
				short_term: 'Short-term employment',
			},
			civil_status: {
				single: 'single',
				married: 'married',
				widowed: 'widowed',
				divorced: 'divorced',
				registered_partnership: 'registered civil partnership',
			},
			health_insurance_type: {
				statutory: 'Statutory',
				private: 'Private',
			},
			contract_type: {
				short_term: 'Short-term employment',
				permanent: 'Permanent employment',
			},
			personnel_type: {
				helper: 'Helper',
				freelancer: 'Freelancer',
			},
			driving_license_classes: {
				none: 'None',
				a1: 'A1 - light motorcycle',
				a2: 'A2 - motorcycle up to 35 kW',
				a: 'A - motorcycle',
				b: 'B - car up to 3.5 t',
				be: 'BE - car with trailer',
				c1: 'C1 - truck up to 7.5 t',
				c1e: 'C1E - C1 with trailer',
				c: 'C - truck',
				ce: 'CE - truck with trailer',
				d1: 'D1 - minibus',
				d1e: 'D1E - D1 with trailer',
				d: 'D - bus',
				de: 'DE - bus with trailer',
				l: 'L - tractor up to 40 km/h',
				t: 'T - tractor up to 60 km/h',
			},
		},
		application: {
			source: {
				app: 'App',
				quick_registration: 'Quick registration',
			},
			source_hint: {
				quick_registration: 'Through the public quick registration, account created with it',
			},
			arrival_type: {
				car_parking: 'By car',
				car_drop_off: 'I am dropped off',
				car_sleeping: 'By car, I sleep in it',
				no_car: 'Without a car',
			},
			arrival_type_hint: {
				car_parking: 'I need a parking space for the whole time.',
				car_drop_off: 'I am dropped off and picked up, no parking needed.',
				car_sleeping: 'I stay overnight in the car on site.',
				no_car: 'By train, bus, bike or on foot.',
			},
			employment_preference: {
				marginal: 'Minijob',
				short_term: 'Short term',
				invoice: 'By invoice',
			},
			employment_preference_hint: {
				marginal: 'Marginal employment',
				short_term: 'Short term employment, at most 70 days a year',
				invoice: 'Self-employed, you send an invoice',
			},
		},
		staffing_request: {
			requirement_type: {
				experience: 'Experience',
				skill: 'Skill',
				driving_license: 'Driving licence',
			},
			status: {
				open: 'Open',
				in_progress: 'In progress',
				done: 'Done',
				declined: 'Declined',
			},
		},
		event_label: {
			locked: 'Locked',
			not_published: 'Not published',
			disable_application: 'Applications not open',
			is_expired: 'Completed',
			is_archived: 'Archived',
		},
	},
	tabs: {
		admin_settings: {
			skills: 'Skills',
			experiences: 'Experiences',
			user_dashboard: 'Home page',
			datev: 'DATEV',
			contracts: 'Contracts',
			// No letterhead in this app, only the mail design (app_eflib, extension letterhead).
			design: 'Mail design',
			groups: {
				staff: 'Staff',
				appearance: 'Appearance',
				system: 'System',
			},
		},
		event_settings: {
			general: 'General',
			info: 'Staff information',
			crews: 'Crews',
			quick_registration: 'Quick registration',
			users: 'People',
		},
		crew_settings: {
			general: 'General',
			users: 'People',
			info: 'Staff information',
			ratings: 'Experiences',
			planning: 'Staff planning',
			timetracking: 'Time tracking',
		},
		user_settings: {
			contact_data: 'Contact details',
			core_data: 'Tax and wage data',
			additional_occupations: 'Qualifications',
			qualifications: 'Qualifications',
			experiences: 'Experiences',
			files: 'Documents',
			contracts: 'Contracts',
			events: 'Events',
			timetracking: 'Time Tracking',
			calendar: 'Calendar',
		},
		user_mails: {
			inbox: 'Inbox',
			outbox: 'Sent',
		},
		hr_mails: {
			inbox: 'Inbox',
			outbox: 'Sent',
		},
	},
	validations: {
		iban: 'Invalid IBAN',
		tax_ident_number: 'Invalid tax identification number',
		sv_number: 'Invalid social security number',
		sv_number_birthday: 'Does not match the date of birth',
		phone: 'Invalid phone number',
		min_age: 'You must be at least 16 years old',
		bic: 'Invalid BIC',
		datev_accountant_id: 'Invalid consultant number',
		datev_client_id: 'Invalid client number',
		valid_email: 'Invalid e-mail address',
		valid_postcode: 'Postal code not found',
		end_before_start: 'The end must not be before the start',
	},
	filters: {
		event: 'Event',
		crew: 'Crew',
		user_skill: 'Skills',
		experience: 'Experience',
		driving_license: 'Driving licence',
		application_state: 'Application status',
		application_source: 'Source',
		experience_any_level: 'Any stars',
		experience_from_level: 'from',
		crew_mode: {
			all: 'All',
			planned: 'Planned',
			preferred: 'Preferred',
		},
		timetracking: {
			day: 'Day',
			person: 'Person',
			state: 'Status',
			states: {
				open: 'Open',
				lead: 'Confirmed by the crew lead',
				member: 'Confirmed by the crew member',
				complete: 'Complete',
				lead_disputed: 'Crew lead: does not fit',
				member_disputed: 'Crew member: does not fit',
			},
			event_day: 'Event day',
		},
	},
	modals: {
		edit_staffing_request: {
			create: 'New staffing request',
			edit: 'Edit staffing request',
			general: 'General',
			demand: 'People needed per day',
			no_positions: 'No demand entered yet.',
			period_hint: 'Please pick a period first.',
			requirements_hint:
				'"People" is how many a line needs per day. The "of them at least" rows say how many of them must bring something. They are not added on top, and one person can meet several.',
			exceeds: 'More than the {count} people of the line on this day',
			blocked: 'Saving works once this is fixed:',
			missing_target:
				'One "of them at least" row does not say yet what it asks for. | {count} "of them at least" rows do not say yet what they ask for.',
			exceeded_days:
				'On one day an "of them at least" row asks for more people than its line has. | On {count} days an "of them at least" row asks for more people than its line has.',
		},
		edit_experience: {
			create: 'New experience',
			edit: 'Edit the experience',
			description_placeholder: 'What a crew lead bases the stars on, e.g. operating and cleaning the tap',
		},
		edit_user_skill: {
			create: 'Create new skill',
			edit: 'Edit skill',
		},
		edit_additional_occupation: {
			create: 'Add employment',
			edit: 'Edit employment',
			delete_title: 'Delete employment',
			delete_text: 'Do you really want to delete the employment at "{item}"?',
		},
		show_application_info: {
			consented_at: 'Consented on {date}',
			title: 'Application details of {fullname}',
		},
		compose_mail: {
			title: 'Send message',
			to: 'To',
			direct_message: 'Direct message',
			hr_team: 'HR team',
			subscribers: 'All subscribers of {event}',
			sent_to: 'No subscriber reached | Sent to one subscriber | Sent to {count} subscribers',
			subject: 'Subject',
			subject_placeholder: 'Enter subject …',
			subject_required: 'Please enter a subject',
			message: 'Message',
			message_placeholder: 'Write a message …',
			message_required: 'Please enter a message',
			send: 'Send',
		},
		edit_crew: {
			create: 'Create new crew',
			edit: 'Edit crew',
		},
		assign_to_event: {
			title: 'Add {name} to an event',
			ok: 'Add',
			hint: 'The person becomes a member of the event, without an application. Crew and days are given in the planning afterwards.',
			no_events: 'There is no running or coming event.',
			booked: 'booked already',
			running: 'running',
			done: '{name} is now part of {event}',
		},
		add_staff: {
			title: 'Add person',
			input: 'Select person',
		},
		invite_to_event: {
			title: 'Invite or add person',
			email: 'Search by name or e-mail address',
		},
		create_event: {
			title: 'Create event',
		},
		review_timetracking: {
			confirm: {
				title: 'Confirm times',
				ok: 'Confirm',
				text_lead: 'Do you confirm the times of {name} as the crew lead?',
				text_member: 'Do you confirm that your times are right?',
				placeholder: 'Optional',
				final_now_lead:
					'The crew member has already confirmed the times. With your confirmation they are final and can no longer be changed.',
				final_now_member:
					'The crew lead has already confirmed the times. With your confirmation they are final and can no longer be changed.',
				final_later_lead:
					'As soon as the crew member confirms as well, the times are final and can no longer be changed.',
				final_later_member:
					'As soon as the crew lead confirms as well, the times are final and can no longer be changed.',
			},
			dispute: {
				title: 'Times do not fit',
				ok: 'Report',
				text_lead:
					'What does not fit in the times of {name}? You can correct them in the time tracking afterwards, and {name} confirms them again.',
				text_member:
					'What does not fit in your times? The crew lead sees your note and can correct the times. You then confirm them again.',
				placeholder: 'For example: the end was 18:00',
			},
		},
		edit_timetracking: {
			title: 'Change the times of {name}',
			minutes: 'minutes',
			end_before_start: 'The end of work is before its start.',
			member_again: 'After saving, {name} has to confirm the changed times again.',
		},
		edit_own_timetracking: {
			title: 'Correct times',
			day: 'Working day',
			not_planned:
				'You are no longer planned in the crew on this day, so you cannot change the times here any more. Ask your crew lead.',
			next_day: 'Ends on the next day, {day}.',
			too_long: 'A working day lasts at most 24 hours.',
			confirm_hint:
				'Saving confirms your times. The crew lead confirms them afterwards; until then you can still change them.',
			after_now: 'The end must not lie after the current time.',
		},
		clock_out_timetracking: {
			title: 'Clock out',
			forgot: 'You have been clocked in since {start}. Enter when you stopped; suggested is the end of the maximum working time allowed.',
			before_start: 'The end must lie after clocking in.',
			after_now: 'The end must not lie after the current time.',
			too_long: 'Clocking in and out lie at most 24 hours apart.',
		},
		clock_in_timetracking: {
			title: 'Clock in',
			after_now: 'The start must not lie after the current time.',
		},
	},
	popovers: {
		event: {
			not_published: {
				title: 'Event not published',
				text: 'The event has not been published yet. Applications only open after publication.',
			},
			expired: {
				title: 'Event is in the past',
				text: 'The event is in the past. Applications are no longer possible.',
			},
		},
		user: {
			min_age: {
				title: 'Under 18',
				text: 'The person is under 18 on at least one day of the event and cannot take on every task.',
			},
			shirt_size: {
				title: 'T-shirt size',
				text: 'The size in which you get work and event t-shirts.',
			},
			address_data_completed: {
				true: {
					title: 'Address data complete',
					text: "The person's address data is complete",
				},
				false: {
					title: 'Address data incomplete',
					text: "Not all of the person's address data has been provided",
				},
			},
			core_data_completed: {
				true: {
					title: 'Core data complete',
					text: "The person's core data is complete",
				},
				false: {
					title: 'Core data incomplete',
					text: "Not all of the person's core data has been provided",
				},
			},
			timetracking_counts: {
				none: {
					title: 'No times recorded',
					text: 'No times have been recorded for this person',
				},
				missing_lead: {
					title: 'Not confirmed by the crew lead',
					text: 'The crew lead has not confirmed all times',
				},
				missing_member: {
					title: 'Not confirmed by the person',
					text: 'The person has not confirmed all times',
				},
				completed: {
					title: 'All times confirmed',
					text: 'The crew lead and the person have confirmed all times',
				},
			},
		},
		timetracking: {
			reviewed_by: '{date} by {name}',
			lead: {
				open: 'Crew lead: open',
				confirmed: 'Confirmed by the crew lead',
				disputed: 'Crew lead: does not fit',
				waiting: 'The crew lead has not confirmed the times yet.',
			},
			member: {
				open: 'Crew member: open',
				confirmed: 'Confirmed by the crew member',
				disputed: 'Crew member: does not fit',
				waiting: 'The crew member has not confirmed the times yet.',
			},
		},
	},
	confirms: {
		delete_registration_background: {
			title: 'Delete the background image?',
			text: 'The image leaves the sign-up page at once, not only on Save.',
		},
		renew_registration_link: {
			title: 'Create a new link',
			text: 'The current quick registration link stops working, also on posters already printed. Continue?',
		},
		delete_staffing_request: {
			title: 'Delete staffing request',
			text: 'Should the staffing request for "{item}" really be removed?',
		},
		delete_experience: {
			title: 'Delete the experience',
			text: 'Really delete the experience "{item}"?',
		},
		delete_experience_rating: {
			title: 'Remove the experience entry',
			text: 'Really remove the entry in "{experience}" from the crew {crew} ({event})? The level is worked out again.',
		},
		delete_user_skill: {
			title: 'Delete skill',
			text: 'Remove the skill "{item}" from the selection in the personal qualifications?',
		},
		delete_file: {
			title: 'Delete file',
			text: 'Do you really want to delete the file "{item}"?',
		},
		reset_user_core_data: {
			title: 'Delete tax and wage data',
			text: 'Do you really want to delete the tax and wage data of "{item}"? This cannot be undone.',
		},
		delete_subscription: {
			title: 'Delete subscription',
			text: 'Do you really want to delete the subscription for the event "{item}"?',
		},
		publish_application: {
			title: 'Send acceptance or rejection',
			text: 'Send the acceptance or rejection to "{item}"? This cannot be undone.',
		},
		publish_many_applications: {
			title: 'Send acceptances and rejections',
			text: 'Do you really want to send the acceptances and rejections? This cannot be undone.',
		},
		delete_crew: {
			title: 'Delete the crew',
			text: 'Really delete the crew "{item}"?',
		},
		remove_event_user: {
			title: 'Remove person',
			text: 'Remove {name} from the event {event}? Applications and assignments stay.',
		},
		lock_event: {
			title: 'Lock event',
			text: 'Lock “{event}”? Nobody can change anything of it afterwards, HR included: no applications, subscriptions, plannings, crews or times. You can unlock it here at any time.',
		},
		export_payroll: {
			title: 'Export the LODAS file',
			text: 'Every checked payslip of {month} that has not been exported yet goes into the file, with the core data of its person. Afterwards it counts as exported, can no longer be changed and is left out of every later export.',
		},
		check_payslip: {
			title: 'Check the payslip',
			text: 'Stamp the payslip of "{item}" as checked? It can no longer be changed afterwards and goes to DATEV with the next export.',
		},
		uncheck_payslip: {
			title: 'Take the check back',
			text: 'Take back the check of the payslip of "{item}"? It can be edited again and only goes into the export once it is checked again.',
		},
		delete_own_timetracking: {
			title: 'Delete times',
			text: 'Do you really want to delete your times of {day} in the crew "{crew}"?',
		},
	},
	user_removal: {
		reasons: {
			open_payslips: '{count} payslip(s) not exported yet.',
			unsettled_months: 'Time trackings without an exported payslip in: {months}.',
			time_trackings: '{count} time tracking(s) - the person has worked.',
			payslips: '{count} payslip(s) must be kept.',
			contracts: '{count} contract(s) must be kept.',
			applications: '{count} application(s) for events.',
		},
	},
	notifications: {
		application_accepted: {
			icon: 'fa-campground',
			title: 'Application accepted',
			text: 'Your application has been accepted. Welcome to the team!',
		},
		application_created: {
			icon: 'fa-campground',
			title: 'Application received',
			text: 'We have received your application. Thank you!',
		},
		application_declined: {
			icon: 'fa-campground',
			title: 'Application declined',
			text: 'Unfortunately, your application was declined.',
		},
		application_reactivated: {
			icon: 'fa-campground',
			title: 'Application reactivated',
			text: 'Your application is active again. Great!',
		},
		application_revoked: {
			icon: 'fa-campground',
			title: 'Application withdrawn',
			text: 'You have withdrawn your application. What a pity!',
		},
		application_waiting: {
			icon: 'fa-campground',
			title: 'Application on the waiting list:',
			text: 'We have put your application on the waiting list. Thank you!',
		},
		contract_send: {
			icon: 'fa-file-signature',
			title: 'Contract available',
			text: 'We have uploaded your contract to your documents.',
		},
		event_published: {
			icon: 'fa-campground',
			title: 'New job offer',
			text: 'Apply now if you are interested.',
		},
		file_uploaded: {
			icon: 'fa-file',
			title: 'New document uploaded',
			text: 'A new document has been uploaded for you',
		},
	},
	components: {
		star_rating: {
			stars: 'no stars | 1 star | {count} stars',
			of_five: '{value} of 5 stars',
			none: 'No experience entered',
			clear: 'Take the entry back',
		},
		experience_pill: {
			ratings: 'no entry | 1 entry | {count} entries',
			override: 'set by HR',
		},
		staffing_requirement: {
			licence: 'Driving licence {class}',
			at_least: '≥ {count}',
		},
		// efOccupiedDaysNote, naming what lies on the days in crewadmin
		occupied_days: {
			note: 'Something is booked from {first} to {last} already (shifts, times, applicants\' days). The dates have to include these days.',
		},
		benefits_badge: {
			label: 'ALG',
			unemployed:
				'Unemployed, draws Bürgergeld/ALG 1 - the pay is set off against it, agree the shifts with the person',
		},
		planning_scheduler: {
			needed_staff: 'Staff needed',
			total: 'Total:',
			employees: 'Staff',
			applications: 'Applications',
			crews: 'Crews',
			preferred_crews: 'Preferred crews',
			other_crews: 'Other crews',
			not_available: 'Not available',
			other_event: 'Other event',
			planned: 'Planned',
			year_count:
				'{count} working days planned in {year}, across all events. Short-term employment allows up to 70 days.',
			year_count_over:
				'{count} working days planned in {year}, across all events: more than the 70 days of short-term employment.',
			export_name: 'Name',
		},
		minor_badge: {
			label: 'U18',
			minor: 'Under 18 during the event - cannot take on every task',
			minor_until: 'Under 18 until just before {date} - cannot take on every task until then',
			unknown: 'The birthday is missing, the age is not known',
			unknown_label: 'Age?',
		},
		tax_fields: {
			tax_category_title: 'Please enter in "tax class" how we have to pay you!',
			tax_category_text:
				'Do not simply enter the tax class you have with another employer. A wrong tax class causes corrections and costs we may charge you. Please find out which tax class is right for you first. As a rough guide:',
			tax_category_six: 'Tax class 6: if you have another job that is already paid under tax class 1.',
			tax_category_one: 'Tax class 1: if you have no other job.',
		},
		occupations: {
			hint: 'Enter your other jobs. They matter for your payroll.',
		},
		driving_license_select: {
			label: 'Licence classes',
		},
		upcoming_events: {
			running: 'running',
			coming: 'coming',
			days: 'no day | 1 day | {count} days',
			member_only: 'added, no days planned yet',
			leads: 'leads {crews}',
		},
		event_locked_note: {
			text: 'This event is locked. Nothing here can be changed until HR unlocks it under Events.',
			since: 'Locked since {date}.',
		},
		time_tracking_tally: {
			summary: '{open} open, {disputed} do not fit',
		},
		working_time_hints: {
			over_max: 'More than the {hours} hours of work a day allowed.',
			break_short: '{worked} of work need a break of at least {minutes} minutes.',
			rules: 'Working time act: a {short} min break after {shortAfter} h, {long} min after {longAfter} h of work, at most {max} h a day.',
		},
		time_tracking_clock: {
			since: 'Clocked in since {start}',
			forgot: 'You forgot to clock out. Enter when you stopped as you clock out.',
			so_far: 'Worked so far',
			after_break: '(after a {minutes} min required break)',
			latest_end: 'Maximum working time {hours} h: clock out by {end}',
			max: 'Maximum working time {hours} h a day',
			breaks: 'Required breaks: {short} min after {shortAfter} h, {long} min after {longAfter} h of work',
			today: 'Today in the crew {crew}',
			recorded: 'Recorded today in the crew {crew}: {times}',
			not_planned: 'You are not planned in a crew today, so you cannot clock in.',
		},
	},
};
